import * as actionTypes from "../actionTypes";

export default (state, action) => {
  switch (action.type) {
    case actionTypes.PROCESS_START:
      return {
        ...state,

        loading: true,
      };

    // -----------------------------
    // Fetch Recruitments
    // -----------------------------

    case actionTypes.FETCH_RECORDS:
      return {
        ...state,
        data: action.payload.data,
        total: action.payload.total,
        count: action.payload.count,
        pagination: action.payload.pagination,
        loading: false,
      };

    // -----------------------------
    // Fetch Single Recruitment
    // -----------------------------

    case actionTypes.FETCH_RECRUITMENT:
      return {
        ...state,
        loading: false,
        error: null,
        recruitment: action.payload.data,
        recruitmentNotes: action.payload.data.recruitmentNotes,
      };

    // -----------------------------
    // Add Recruitment
    // -----------------------------

    case actionTypes.ADD_RECORD:
      return {
        ...state,

        recruitments: [action.payload.data, ...state.recruitments],

        loading: false,
      };

    // -----------------------------
    // Update Recruitment
    // -----------------------------

    case actionTypes.UPDATE_RECORD:
      return {
        ...state,

        data: state.data.map((recruitment) =>
          recruitment._id === action.payload._id ? action.payload : recruitment,
        ),

        loading: false,
      };

    // -----------------------------
    // Update Recruitment Notes
    // -----------------------------

    case actionTypes.ADD_RECRUITMENT_NOTES:
      return {
        ...state,
        loading: false,
        recruitmentNotes: action.payload,
      };

    // -----------------------------
    // Get All Languages and Dialects
    // -----------------------------

    case actionTypes.GET_ALL_LANGUGAGES:
      return {
        ...state,
        languages: action.payload,
      };

    case actionTypes.GET_ALL_DIALECTS:
      return {
        ...state,
        dialects: action.payload,
      };

    // -----------------------------
    // Errors
    // -----------------------------

    case actionTypes.FETCH_ERRORS:
      return {
        ...state,

        loading: false,

        error: action.payload,
      };

    default:
      return state;
  }
};
